import { Button, Center, Flex, Loader, Paper, Table, Text, Title, createStyles } from "@mantine/core"
import { formatDateTime } from "@medplum/core";
import { StatusBadge, useMedplum } from "@medplum/react";
import { MouseEvent, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";


const useStyles = createStyles((theme) => ({
    table: {
        marginTop: "30px"
    },
    thead: {
        backgroundColor: '#BEDEF8',
        borderRadius: 4,
    },
}));
interface Props {
  pName: any;
}

export const Reports: React.FC<Props> = ({ pName }) => {
  const { patientId } = useParams();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const medplum = useMedplum();
  const [reports, setReports] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const tableHeaders = [
    "Report Name",
    "Category",
    "Performer",
    "Date Issued On",
    "Effective Date",
    "Status",
  ];

  useEffect(() => {
    getReports();
  }, [patientId]);

  const getReports = async () => {
    const res = await medplum.searchResources(
      "DiagnosticReport",
      `patient=Patient/${patientId}`
    );
    setReports(res);
    setIsFetching(false);
  };

  const getCategory = (category: any) => {
    let text = "";
    if (category.length > 0) {
      for (let i = 0; i < category.length; i++) {
        if (category[i].coding) {
          for (let j = 0; j < category[i].coding.length; j++) {
            text = category[i].coding[j].display;
          }
        }
      }
      return text;
    }
  };

  return (
    <>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "0px",
          marginRight: "0px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
        withBorder
      >
        <Flex justify={"space-between"}>
          <Title>Diagnostic Reports</Title>
        </Flex>
        <Table className={classes.table}>
          <thead className={classes.thead}>
            <tr>
              {tableHeaders.map((val) => {
                return <th key={val}>{val}</th>;
              })}
            </tr>
          </thead>
          {
            <tbody>
              {reports.map((data: any) => (
                <tr
                style={{cursor:"pointer"}}
                  key={data.id}
                  onClick={() => {
                    navigate(`/admin/diagnosticreport/${data.id}?name=${pName}`);
                  }}
                >
                  <td>{data.code?.text}</td>
                  <td>{getCategory(data.category)}</td>
                  <td>
                    {data.performer.length > 0 ? data.performer[0].display : ""}
                  </td>
                  <td>{formatDateTime(data.issued)}</td>
                  <td>{formatDateTime(data.effectiveDateTime)}</td>
                  <td>
                    <StatusBadge status={data.status as string} />
                  </td>
                </tr>
              ))}
            </tbody>
          }
        </Table>
        {reports?.length === 0 && !isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Text size="xl" color="dimmed">
              No results
            </Text>
          </Center>
        )}
        {isFetching && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Loader />
          </Center>
        )}
      </Paper>
    </>
  );
};